// Maps a department id to a lucide-react icon, per the table in the README.
//
// Lucide is the production icon set. The handoff's custom SVGs in data.jsx
// served as the design spec; lucide-equivalents preserve the same outline
// style and stroke metric.

import {
  Building2,
  CircleDollarSign,
  Users,
  ShoppingBag,
  Monitor,
  Store,
  ShieldCheck,
  Handshake,
  Network,
  ClipboardList,
  Phone,
  type LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  commerce: ShoppingBag,
  crm: Handshake,
  it: Monitor,
  hr: Users,
  retail: Store,
  stores: ClipboardList,
  compliance: ShieldCheck,
  connect: Network,
  comms: Phone,
  finance: CircleDollarSign,
};

type Props = {
  deptId: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
};

export function DeptIcon({
  deptId,
  size = 18,
  className,
  strokeWidth = 1.6,
}: Props) {
  const Icon = MAP[deptId] ?? Building2;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden
    />
  );
}
